export type MaskKeepEdgesOptions = {
  /** Символ маски в середине. По умолчанию `*`. */
  maskChar?: string;
  /** Сколько символов слева оставить открытыми. По умолчанию `4`. */
  leadingVisible?: number;
  /** Сколько символов справа оставить открытыми. По умолчанию `4`. */
  trailingVisible?: number;
  /**
   * Длина средней маски (фиксированное число символов), независимо от скрытой длины.
   * По умолчанию `4` — вид `1111****1111`.
   */
  middleMaskLength?: number;
};

/**
 * Маскирует середину строки, оставляя видимыми края (например `1111****1111` или `0f5e****5842`).
 * Середина всегда из `middleMaskLength` символов `maskChar`, без «растягивания» под длину ID.
 */
export function maskKeepEdges(value: string, options?: MaskKeepEdgesOptions): string {
  if (!value) {
    return '';
  }

  const maskChar = options?.maskChar ?? '*';
  const leading = Math.max(0, options?.leadingVisible ?? 4);
  const trailing = Math.max(0, options?.trailingVisible ?? 4);
  const middleLen = Math.max(1, options?.middleMaskLength ?? 4);

  if (value.length <= leading + trailing) {
    return value;
  }

  const middle = maskChar.repeat(middleLen);
  return value.slice(0, leading) + middle + value.slice(-trailing);
}
